import React, { useState } from "react";
import { Pagination, Tooltip, IconButton, Grid, Box } from "@mui/material";
import { useTheme } from "@emotion/react";
import DeleteIcon from '@mui/icons-material/Delete';
import {StyledH3Heading, StyledGrid, StyledLink, StyledCards}  from "../style/StyledComponents";
import { useNavigate } from "react-router-dom";


function DeleteTabButton({ embedId, handleDeleteEvent }) {
    const theme = useTheme();
    return (
        <Tooltip title="Delete button would delete the sections and corresponding notes" size="md" arrow>
            <IconButton
                key={embedId}
                onClick={(e) => { e.preventDefault(); handleDeleteEvent(embedId) }}
                sx={{ padding: 0, marginLeft: 'auto', color: theme.palette.secondary.main }}
            >
                <DeleteIcon />
            </IconButton>
        </Tooltip>
    );
}

const PodcastHistoryBoard = ({ podcasts, handleDeleteClick}) => {
    const theme = useTheme();
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 5;

    const Iconstyle = { width: '100%', height: "100%", objectFit: 'cover', cursor: 'pointer' };

    const handlePageChange = (event, value) => {
        setCurrentPage(value);
    };

    const navigate = useNavigate();
    const handlePodcastClick = (podcast) => {
        if (podcast && podcast.id) {
            const arr = podcast.id.split("#");
            navigate(`/podcasts/${arr[0]}/mp3/${arr[1]}`, { state: {...podcast}});
        }
    };

    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = podcasts ? podcasts.slice(indexOfFirstItem, indexOfLastItem) : [];

    return (
        <>
        <StyledGrid container sx={{padding: "1rem"}}>
            <StyledGrid container item>
                <Grid item>
                    <StyledH3Heading>History</StyledH3Heading>
                </Grid>
            </StyledGrid>
            <StyledGrid container spacing={2}>
                {currentItems.map((podcast) => (
                    <Grid item key={podcast.id}>
                        <StyledCards>
                            <img
                                src={podcast.image}
                                alt={podcast.title}
                                style={Iconstyle}
                                onClick={() => handlePodcastClick(podcast)} />
                            <Grid container sx={{ padding: "8px" }} alignItems="center">
                                <Grid item xs={10}>
                                    <StyledLink title={podcast.title} onClick={() => handlePodcastClick(podcast)} />
                                </Grid>
                                <Grid item xs={2} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                                    <DeleteTabButton
                                        embedId={podcast.id}
                                        handleDeleteEvent={handleDeleteClick}
                                    />
                                </Grid>
                            </Grid>
                        </StyledCards>
                    </Grid>
                ))}
            </StyledGrid>
            <Box display="flex" justifyContent="center" width="100%" mt={2}>
                <Pagination
                    count={Math.ceil(podcasts.length / itemsPerPage)}
                    page={currentPage}
                    onChange={handlePageChange}
                    style={{ margin: "20px" }}
                />
            </Box>
        </StyledGrid>
        </>
    );
};

export default PodcastHistoryBoard;
